module.exports = __webpack_public_path__ + "img/PD1501004851935657984.869f2cf6.png";